// クリックデモの仕込み：window.fetch を横取りして demoServer に流す＋操作ウィジェットを表示。
// REACT_APP_DEMO=1 のビルドでのみ index.js から install() される。実データ・実LINEには繋がらない。
// ルーティングは HashRouter（URL のハッシュ部）なので、/uidemo/ 配下の静的配信でも
// サーバのSPAフォールバックに依存せず動く（打刻等の反映はリロードで再取得）。
import { handle, setRole, getRole, reset, isWorking } from "./demoServer";
import { openLineDemo } from "./lineDemo";

const HOME_HASH = "#/employee";

function patchFetch() {
  const orig = window.fetch.bind(window);
  window.fetch = async (input, options = {}) => {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    let u;
    try { u = new URL(url, window.location.origin); } catch (e) { return orig(input, options); }
    if (!u.pathname.startsWith("/api/")) return orig(input, options);
    const method = options.method || (typeof input !== "string" && input && input.method) || "GET";
    let body = null;
    if (typeof options.body === "string") { try { body = JSON.parse(options.body); } catch (e) { body = null; } }
    const { status, json } = handle(method, u.pathname, u.searchParams, body || {});
    await new Promise((r) => setTimeout(r, 120)); // それっぽい遅延
    return new Response(JSON.stringify(json), { status, headers: { "Content-Type": "application/json" } });
  };
}

// ハッシュを home に合わせてからリロード（更新後の状態でホーム/履歴を再取得させる）。
function reloadHome() {
  window.location.hash = HOME_HASH;
  window.location.reload();
}

function el(tag, style, text) {
  const e = document.createElement(tag);
  if (style) e.style.cssText = style;
  if (text != null) e.textContent = text;
  return e;
}

function chooseRole(role) {
  setRole(role);
  localStorage.setItem("isLoggedIn", "true");
  reloadHome();
}

// 初回：未ログインなら「社員／経営者」選択モーダル。ログイン済みなら home のハッシュへ。
function ensureEntry() {
  if (localStorage.getItem("isLoggedIn") === "true") {
    if (!window.location.hash.startsWith(HOME_HASH)) window.location.hash = HOME_HASH; // レンダ前に設定＝mypageで起動
    return;
  }
  const back = el("div", "position:fixed;inset:0;z-index:99998;background:rgba(24,25,27,.55);display:flex;align-items:center;justify-content:center;padding:20px;font-family:system-ui,'Noto Sans JP',sans-serif");
  const card = el("div", "background:#fff;border-radius:18px;max-width:380px;width:100%;padding:26px 24px;box-shadow:0 20px 50px -20px rgba(0,0,0,.4)");
  card.appendChild(el("div", "font-size:12px;font-weight:600;letter-spacing:.08em;color:#83868b;margin-bottom:6px", "DEMO"));
  card.appendChild(el("div", "font-size:19px;font-weight:700;color:#18191b;margin-bottom:6px", "勤怠マイページ デモ"));
  card.appendChild(el("div", "font-size:13.5px;line-height:1.7;color:#5c5f63;margin-bottom:20px", "どちらの立場で確認しますか？（あとで右下のパネルから切替できます）"));
  const mk = (label, sub, role) => {
    const b = el("button", "display:block;width:100%;text-align:left;border:1px solid rgba(18,20,24,.12);background:#fff;border-radius:12px;padding:14px 16px;margin-bottom:10px;cursor:pointer");
    b.appendChild(el("div", "font-size:15px;font-weight:600;color:#18191b", label));
    b.appendChild(el("div", "font-size:12.5px;color:#83868b;margin-top:3px", sub));
    b.onmouseenter = () => { b.style.background = "#f4f5f6"; };
    b.onmouseleave = () => { b.style.background = "#fff"; };
    b.onclick = () => chooseRole(role);
    return b;
  };
  card.appendChild(mk("社員として見る", "打刻・履歴・各種申請・給与明細など", "employee"));
  card.appendChild(mk("経営者として見る", "承認・シフト管理・給与アップロードなど", "executive"));
  back.appendChild(card);
  (document.body || document.documentElement).appendChild(back);
}

function mountWidget() {
  const role = getRole();
  const working = isWorking();
  const wrap = el("div", "position:fixed;right:14px;bottom:14px;z-index:99997;background:#fff;border:1px solid rgba(18,20,24,.12);border-radius:14px;box-shadow:0 10px 30px -12px rgba(0,0,0,.35);padding:12px 13px;width:212px;font-family:system-ui,'Noto Sans JP',sans-serif");
  wrap.appendChild(el("div", "font-size:11px;font-weight:700;letter-spacing:.06em;color:#83868b;margin-bottom:8px", "デモ操作（実データ非接続）"));

  const roleRow = el("div", "display:flex;gap:6px;margin-bottom:9px");
  const roleBtn = (label, r) => {
    const on = role === r;
    const b = el("button", `flex:1;font-size:12px;font-weight:600;padding:7px 0;border-radius:8px;cursor:pointer;border:1px solid ${on ? "#18191b" : "rgba(18,20,24,.15)"};background:${on ? "#18191b" : "#fff"};color:${on ? "#fff" : "#5c5f63"}`, label);
    b.onclick = () => { setRole(r); reloadHome(); };
    return b;
  };
  roleRow.appendChild(roleBtn("社員", "employee"));
  roleRow.appendChild(roleBtn("経営者", "executive"));
  wrap.appendChild(roleRow);

  // 本番の打刻は LINE 経由。デモでも「LINEを開く→出勤/退勤ページ」の動線を再現する。
  const line = el("button", "display:flex;align-items:center;justify-content:center;gap:7px;width:100%;font-size:13px;font-weight:700;padding:10px 0;border-radius:9px;cursor:pointer;border:none;margin-bottom:7px;color:#fff;background:#06C755");
  line.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="#fff" aria-hidden="true"><path d="M12 3C6.9 3 2.75 6.33 2.75 10.44c0 3.68 3.29 6.76 7.74 7.35.3.06.71.2.81.46.09.24.06.6.03.85l-.13.79c-.04.24-.19.93.82.51 1.01-.42 5.45-3.21 7.44-5.5 1.37-1.5 2.03-3.03 2.03-4.71C21.5 6.33 17.1 3 12 3z"/></svg><span style="color:#fff">LINEを開く</span>';
  line.onclick = () => { openLineDemo(reloadHome); };
  wrap.appendChild(line);
  wrap.appendChild(el("div", "font-size:10.5px;line-height:1.5;color:#b6b9be;margin-bottom:8px", working ? "勤務中。LINEから退勤するとホーム/履歴に反映。" : "本番はLINEで打刻。ここで出勤の流れを再現できます。"));

  const rst = el("button", "display:block;width:100%;font-size:11.5px;color:#83868b;background:none;border:none;cursor:pointer;padding:2px", "データをリセット");
  // バッジの既読は demoServer の state.badgeSeen が持つので reset() だけで戻る
  // （旧 localStorage 方式の clearRead は廃止）。
  rst.onclick = () => { reset(); reloadHome(); };
  wrap.appendChild(rst);

  (document.body || document.documentElement).appendChild(wrap);
}

export function install() {
  patchFetch();
  ensureEntry(); // レンダ前にハッシュ確定（logged in なら mypage 起動）
  const addWidget = () => { if (localStorage.getItem("isLoggedIn") === "true") mountWidget(); };
  if (document.body) addWidget();
  else window.addEventListener("DOMContentLoaded", addWidget);
}
